import { LockOutlined, LoginOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Form, Input } from 'antd'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { IAuthState } from '..'
import { ISettingTypeState } from '../../siteSettings/components/settings'
import * as auth from '../redux/actions'

export function Login() {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const history = useHistory()
  const params: { id: string } = useParams()
  const authResp: IAuthState = useSelector((state: any) => state.auth)
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const loading = authResp?.loading
  const [userId, setUserId] = useState(authResp?.userId)
  const [applicationCredentials, setApplicationCredentials] = useState([])
  const [loginState, setLoginState] = useState('verifyUser')
  const [currentEmail, setCurrentEmail] = useState('')

  useEffect(() => {
    let arrayOfCredentials: any = []
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData?.['Application Credentials']?.forEach((item: any) => {
        arrayOfCredentials.push(item)
      })
    }
    setApplicationCredentials(arrayOfCredentials)
  }, [settingTypeData])

  useEffect(() => {
    applicationCredentials?.forEach((items: any) => {
      if (items.name === 'loginByEmail' && items.value === '1') setLoginState('loginByEmail')
      if (items.name === 'loginByPhoneNumber' && items.value === '1') setLoginState('loginByPhoneNumber')
      if (items.name === 'loginByUsername' && items.value === '1') setLoginState('loginByUsername')
    })
  }, [applicationCredentials])

  useEffect(() => {
    if (!authResp.firstLogin && !isEmpty(authResp?.data)) setLoginState('loginUser')
    if (authResp.firstLogin && !isEmpty(authResp?.data)) setLoginState('verifyChangeNewPassword')
    if (authResp?.setNewPasswordSuccess) setLoginState('loginUser')
    if (authResp?.userId) setUserId(authResp?.userId)
  }, [authResp])

  useEffect(() => {
    if (!isEmpty(params?.id)) {
      setUserId(params?.id)
      setLoginState('verifyChangeNewPassword')
    }
  }, [params])

  useEffect(() => {
    if (authResp?.is2FALogin && currentEmail) {
      history.push({ pathname: '/auth/verify-otp', state: { email: currentEmail } })
    }
  }, [authResp?.is2FALogin, currentEmail])

  const handleFinish = (values: { email: string; password: string }) => {
    dispatch(auth.actions.login(values.email, values.password))
    setCurrentEmail(values.email)
  }

  return (
    <Form form={form} onFinish={handleFinish} layout='vertical' requiredMark={false}>
      {/* <h4 className='auth-title text-center' data-cy='login-box-message'>
        Sign In
      </h4> */}

      <Form.Item
        name='email'
        label='Email or Username'
        rules={[
          { required: true, message: 'Email or Username is required' },
          { min: 3, message: 'Minimum 3 symbols' },
          { max: 50, message: 'Maximum 50 symbols' },
        ]}
      >
        <Input
          prefix={<UserOutlined />}
          placeholder='Email or Username'
          autoComplete='off'
          size='large'
          data-cy='login-email-field'
        />
      </Form.Item>

      <Form.Item
        name='password'
        label='Password'
        rules={[
          { required: true, message: 'Password is required' },
          { min: 3, message: 'Minimum 5 symbols' },
          { max: 50, message: 'Maximum 50 symbols' },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder='Password'
          size='large'
          data-cy='login-password-field'
        />
      </Form.Item>

      {/* <div className='text-end mb-4' style={{ marginTop: '-8px' }}>
        <Link
          to='/auth/forgot-password'
          className='auth-link'
          data-cy='login-forgot-password-button'
        >
          Forgot Password?
        </Link>
      </div> */}

      <Form.Item>
        <Button
          htmlType='submit'
          size='large'
          block
          loading={loading}
          icon={<LoginOutlined />}
          className='btn-auth-submit'
          data-cy='login-submit-button'
        >
          SIGN IN
        </Button>
      </Form.Item>
    </Form>
  )
}
